import gsap from "gsap"
import { settings } from "../settings"
import { pixiApp } from "./initializePixi"
import { gameAssets } from "./gameUI"
import { utils } from "pixi.js"

export async function resolveAndKillTweens(targets) {
    const tweens = gsap.getTweensOf(targets)
    for (const tween of tweens) {
        if ((tween)._prom) (tween)._prom()
    }
    gsap.killTweensOf(targets)
}

export function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const sceneTransition = async (gameObject, duration, cb = () => { }) => {
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        alpha: 0,
        duration,
        ease: 'sine.in',
        onComplete: cb
    })
        .to(gameObject, {
            alpha: 1,
            duration,
            ease: 'sine.in'
        })
}

export const tweenFade = async (gameObject, isVisible, duration = 0.2, cb = () => { }) => {
    gameObject.visible = true
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        alpha: isVisible ? 1 : 0,
        duration,
        ease: 'sine.in',
        onComplete: cb
    })
}


export async function tweenFadeAppear(gameObject, isVisible, timeDuration = 0.2, cb = () => { }) {
    if (!gameObject) return
    if (!gameObject?.initialX) gameObject.initialX = gameObject.x
    if (!gameObject?.finalY) gameObject.finalY = gameObject.y
    if (!gameObject?.finalX) gameObject.finalX = gameObject.x
    if (!gameObject?.finalY) gameObject.finalY = gameObject.y

    const xPos = isVisible ? gameObject.finalX : gameObject.initialX
    const yPos = isVisible ? gameObject.finalY : gameObject.initialY
    const duration = timeDuration

    if (isVisible) {
        gameObject.visible = true
        gameObject.alpha = isVisible ? 0 : 1
    }

    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        x: xPos,
        y: yPos,
        alpha: isVisible ? 1 : 0,
        duration,
        ease: 'sine.in',
        onComplete: () => {
            gameObject.visible = isVisible
            cb()
            return
        }
    })
}

export const tweenScaleAppear = async (gameObject, duration = 0.2, callbackFunction = () => { }) => {
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        pixi: {
            scale: 2
        },
        duration: duration * 0.5,
        ease: 'power1.in'
    })
        .to(gameObject, {
            pixi: {
                scale: 1
            },
            duration: duration * 0.5,
            ease: 'power1.out',
            onComplete: () => {
                callbackFunction()
                return
            }
        })
}

export const tweenScaleDisAppear = async (gameObject, duration = 0.2, callbackFunction = () => { }) => {
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        pixi: {
            scale: 0
        },
        duration,
        ease: 'power2',
        onComplete: () => {
            callbackFunction()
            return
        }
    })
}

export const incrementValue = async (gameObject, value, duration) => {
    const tl = gsap.timeline()

    tl.to(gameObject, {
        duration: duration - 4,
        repeat: 1,
        repeatDelay: Infinity,
        ease: "expo.out",
        onUpdate: function () {
            const amount = (Math.floor(this.progress() * value * 100) / 100).toFixed(2)
            gameObject.text = amount
        },
        onComplete: function () {
            tl.kill()
        }
    })
}

export async function tweenScale(gameObject, scaleX, scaleY, timeDuration = 0.5) {
    if (!gameObject) return

    const duration = timeDuration
    const visibleDuration = 0.1

    resolveAndKillTweens(gameObject)

    const tl = gsap.timeline()
    await tl.to(gameObject.scale, {
        x: scaleX,
        y: scaleY,
        duration,
        //  onComplete: () => gameObject.visible = isVisible
    })
    await tl.to(gameObject, {
        alpha: 0,
    })
}

export const scaleFactorScaleToFit = (elementWidth, elementHeight) => {
    let scale = 1
    scale = settings.currentWidth < settings.currentHeight ?
        settings.currentWidth / elementWidth :
        settings.currentHeight / elementHeight

    return scale
}

export const viewAppear = {
    view: () => {
        gameAssets.gameScreen.viewAppear = () => {
            pixiApp.app.renderer.view.style.width = `${gameAssets.gameScreen.windowWidth}px`
            pixiApp.app.renderer.view.style.height = `${gameAssets.gameScreen.windowHeight}px`
            window.scrollTo(0, 0)

            pixiApp.app.renderer.resize(settings.currentWidth, settings.currentHeight)
        }
    }
}

export function pixiView() {
    pixiApp.app.renderer.view.style.width = `${settings.windowWidth}px`;
    pixiApp.app.renderer.view.style.height = `${settings.windowHeight}px`;
    window.scrollTo(0, 0);
}


export const scaleFactorScaleStretch = (elementWidth, elementHeight) => {
    let scale = 1
    if (utils.isMobile.any) {
        scale = settings.currentWidth < settings.currentHeight ?
            settings.currentHeight / elementHeight :
            settings.currentWidth / elementWidth
    } else {
        scale = settings.currentWidth < settings.currentHeight ?
            settings.currentWidth / elementWidth :
            settings.currentHeight / elementHeight
    }
    if (elementWidth < elementHeight) scale = elementHeight / window.innerHeight
    else scale = window.innerHeight / elementHeight

    return scale
}

export async function tweenPopScale(gameObject, timeDuration = 1, scaleFactor = 1.2) {
    if (!gameObject || !gameObject.scale) return;

    const duration = timeDuration / 2; // Half for scale-up and half for scale-down

    // Ensure no other tweens interfere with this object
    gsap.killTweensOf(gameObject.scale);

    // Create and execute the timeline animation
    return gsap.timeline()
        .to(gameObject.scale, {
            x: scaleFactor,
            y: scaleFactor,
            duration,
            ease: "power2.out",
        })
        .to(gameObject.scale, {
            x: 1,
            y: 1,
            duration,
            ease: "power2.in",
        });
}

export function tweenSirenAlpha(gameObject, timeDuration = 1) {
    if (!gameObject || typeof gameObject.alpha !== "number") return;

    // Ensure no other tweens interfere with this object
    gsap.killTweensOf(gameObject);

    // Create a repeating timeline for the siren effect
    gsap.timeline({ repeat: -1 }) // Repeat indefinitely
        .to(gameObject, {
            alpha: 0,
            duration: timeDuration / 2,
            ease: "power2.inOut",
        })
        .to(gameObject, {
            alpha: 1,
            duration: timeDuration / 2,
            ease: "power2.inOut",
        });
}

export function tweenPulsate(gameObject, timeDuration = 1, scaleFactor = 0.8, times = -1) {
    if (!gameObject || typeof gameObject.alpha !== "number") return;

    // Ensure no other tweens interfere with this object    
    gsap.killTweensOf(gameObject);

    // Create a repeating timeline for the siren effect
    gsap.timeline({ repeat: times, yoyo: true }) // Repeat indefinitely with smooth yoyo effect
        .to(gameObject, {
            pixi: {
                scale: scaleFactor
            },
            duration: timeDuration,
            ease: "power1.inOut", // Smooth easing
        });
}
export function tweenPulsateUpgrade(gameObject, timeDuration = 0.5, scaleFactor = 1.2, times = 3) {
    if (!gameObject || typeof gameObject.alpha !== "number") return;

    gsap.killTweensOf(gameObject);

    const tl = gsap.timeline();

    // Start at scale 0
    tl.set(gameObject, {
        pixi: {
            scale: 0
        }
    });

    // Instantly jump to scale 1 (to start pulsating from here)
    tl.to(gameObject, {
        pixi: {
            scale: 1
        },
        duration: 0.01
    });

    // Pulsate between 1 and scaleFactor
    tl.to(gameObject, {
        pixi: {
            scale: scaleFactor
        },
        duration: timeDuration,
        ease: "power1.inOut",
        yoyo: true,
        repeat: times
    });

    // Finally shrink back to 0
    tl.to(gameObject, {
        pixi: {
            scale: 0
        },
        duration: timeDuration,
        ease: "power1.inOut"
    });
}


export function tweenFadeOut(gameObject, timeDuration = 1) {
    // Ensure no other tweens interfere with this object
    gsap.killTweensOf(gameObject);

    // Create a repeating timeline for the siren effect
    gsap.timeline() // Repeat indefinitely
        .to(gameObject, {
            alpha: 0,
            ease: "power2.inOut",
        })
}

export const scaleFactor = (gameScreen, elementWidth) => gameScreen / elementWidth

